import _filter from 'lodash/filter';
import _sortBy from 'lodash/sortBy';
import { config } from './HomePageConfig';

export default function getHomePageConfig() {
  /* filter configs that are in the future and not relevant */
  const configKeys = Object.keys(config);
  const validConfigs = _filter(configKeys, timestamp => {
    const date = new Date(timestamp);
    return date < new Date();
  });
  /* find the first config from those that are valid */
  const sortedConfigs = _sortBy(validConfigs, timestamp => {
    return new Date(timestamp);
  }).reverse();
  return config[sortedConfigs[0]];
}
